import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { CGV } from './pages/CGV';
import { Legal } from './pages/Legal';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { OrganizationSchema } from './components/StructuredData';
import './i18n';
import './styles/globals.css';

function App() {
  const { t, i18n } = useTranslation();

  return (
    <HelmetProvider>
      {/* Default Meta Tags */}
      <Helmet>
        <html lang={i18n.language} />
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#FF7A50" />
        <link rel="icon" type="image/svg+xml" href="/vite.svg" />
        
        {/* Preconnect to External Resources */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link rel="preconnect" href="https://assets.calendly.com" />
        
        {/* Performance Optimization */}
        <link rel="dns-prefetch" href="https://blog.wiserank.ai" />
        <link rel="dns-prefetch" href="https://hook.eu2.make.com" />
      </Helmet>

      {/* Organization Schema */}
      <OrganizationSchema />

      <div className="min-h-screen flex flex-col bg-white dark:bg-black text-gray-900 dark:text-white relative">
        {/* Skip Navigation Link for Accessibility */}
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-white dark:focus:bg-gray-800 focus:text-gray-900 dark:focus:text-white focus:rounded-lg focus:shadow-lg"
        >
          Skip to main content
        </a>

        <Navbar />
        <main id="main-content" className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/legal" element={<Legal />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;